/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_All_FiltersInputs */

const en_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset all filters`)
};

const de_clear_all_filters = /** @type {(inputs: Clear_All_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Filter zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Reset all filters" |
*
* @param {Clear_All_FiltersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_all_filters = /** @type {((inputs?: Clear_All_FiltersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_All_FiltersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_clear_all_filters(inputs)
	return en_clear_all_filters(inputs)
});